import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/compound-assessments';

export const RenderPreviewTitle: React.FC = () => {
  return (
    <Typography2 component="p" variant="bodySecondary" color="supportText">
      {_t('File preview')}
    </Typography2>
  );
};

export default RenderPreviewTitle;
